export default __webpack_public_path__ + "static/4-ae4a6529f171145eab316c363f0dbba6.jpeg";